import { AppointmentFlow } from '@pages/user-view/pages/appointment-flow/appointment-flow-routes.names';
import { UserView } from '@pages/user-view/user-view-routes.names';

export const SelectBusiness = 'select-business';
export const AppointmentFlowSelectBusiness = `/${UserView}/${AppointmentFlow}/${SelectBusiness}`;
